import { Component, OnDestroy, OnInit } from "@angular/core";

import { Observable, of } from "rxjs";
import { map, shareReplay, switchMap } from "rxjs/operators";

import { SubSink } from "@dffedb/rxjs";
import { AppserverBrugerCredentialsRepository } from "@e-forsyning/common/credentials";
import { Installation } from "@e-forsyning/common/installation";
import { AktuelBrugersInstallationerObserver } from "@e-forsyning/common/installation";
import { RedirectService } from "@e-forsyning/common/router";

import { DefaultComponentViewModel } from "./default.component.view-model";

@Component({
    templateUrl: "./default.component.html",
    styleUrls: ["./default.component.scss"]
})
export class DefaultComponent implements OnInit, OnDestroy {
    private subs = new SubSink();
    public vm$: Observable<DefaultComponentViewModel>;

    constructor(
        private readonly brugerCredentialsRepository: AppserverBrugerCredentialsRepository,
        private readonly aktuelBrugersInstallationerObserver: AktuelBrugersInstallationerObserver,
        private readonly redirectService: RedirectService
    ) {}

    public ngOnInit(): void {
        const erLoggetInd$ = this.brugerCredentialsRepository.valueChanges.pipe(map((credentials) => !!credentials.cryptId));
        const installationer$ = this.aktuelBrugersInstallationerObserver.valueChanges;
        this.vm$ = erLoggetInd$.pipe(
            switchMap((erLoggetInd) =>
                erLoggetInd
                    ? installationer$.pipe(map((installationer) => ({ erLoggetInd, installationer })))
                    : of({ erLoggetInd, installationer: [] as Installation[] })
            ),
            shareReplay(1)
        );

        this.subs.sink = this.vm$.subscribe((vm) => {
            const erPassivForbruger =
                vm.installationer.length === 0 || (vm.installationer.length === 1 && vm.installationer[0].installationNr === 0);

            if (!vm.erLoggetInd) {
                this.redirectService.redirectTilLogin();
            } else if (erPassivForbruger) {
                this.redirectService.redirectTilMineDokumenter();
            } else if (vm.installationer.length === 1) {
                this.redirectService.redirectTilMitForbrug();
            } else {
                this.redirectService.redirectTilInstallationer();
            }
        });
    }

    public ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
